<template>
	<!-- 右键列表 -->
	<transition name="el-fade-in-linear">
		<!-- 在某个文件上右键 -->
		<ul
			class="right-menu-list"
			id="rightMenuList"
			v-show="visible"
			v-if="selectedFile !== undefined"
			:style="`top: ${rightMenu.top};right: ${rightMenu.right};bottom: ${rightMenu.bottom};left: ${rightMenu.left};`"
		>
			<li
				class="right-menu-item"
				@click="
					$file.handleFileNameClick(selectedFile, 0, permission.preview === 1)
				"
				v-if="seeBtnShow"
			>
				<i class="el-icon-view"></i> 查看
			</li>
			<li
				class="right-menu-item"
				@click="$file.handleWPSView(selectedFile, 0, permission.preview === 1)"
				v-if="wpsBtnShow"
			>
				<i class="el-icon-view"></i> WPS查看
			</li>
			<li
				class="right-menu-item"
				@click="handleDeleteFileBtnClick(selectedFile)"
				v-if="deleteBtnShow"
			>
				<i class="el-icon-delete"></i> 删除
			</li>
			<li
				class="right-menu-item"
				@click="handleRestoreFileBtnClick(selectedFile)"
				v-if="restoreBtnShow"
			>
				<i class="el-icon-refresh-left"></i> 还原
			</li>
			<li
				class="right-menu-item"
				@click="handleRenameFileBtnClick(selectedFile)"
				v-if="renameBtnShow"
			>
				<i class="el-icon-edit-outline"></i> 重命名
			</li>
			<li
				class="right-menu-item"
				@click="handleDownloadFile(selectedFile)"
				v-if="downloadBtnShow"
			>
				<i class="el-icon-download"></i> 下载
			</li>
			<li
				class="right-menu-item"
				@click="handleShowDetailInfo(selectedFile)"
				v-if="detailInfoBtnShow"
			>
				<i class="el-icon-document"></i> 文件详情
			</li>
			<li class="right-menu-item" @click="handleCloseRightMenu()">
				<i class="el-icon-circle-close"></i> 取消
			</li>
		</ul>
		<!-- 在空白处右键，右键列表展示刷新，新建文件夹等操作按钮 -->
		<ul
			class="right-menu-list add"
			id="rightMenuList"
			v-show="visible"
			v-else
			:style="`top: ${rightMenu.top};right: ${rightMenu.right};bottom: ${rightMenu.bottom};left: ${rightMenu.left};`"
		>
			<li class="right-menu-item" @click="callback('confirm')">
				<i class="el-icon-refresh"></i> 刷新
			</li>
			<template v-if="fileType === 0">
				<!-- <el-divider />
				<li class="right-menu-item" @click="handleClickAddFolderBtn">
					<i class="el-icon-folder-add"></i> 新建文件夹
				</li> -->
				<el-divider v-if="uploadFileBtnShow" />
				<li
					class="right-menu-item"
					@click="handleUploadFileBtnClick(1)"
					v-if="uploadFileBtnShow"
				>
					<i class="el-icon-upload2"></i> 上传文件
				</li>
				<el-divider />
				<li class="right-menu-item" @click="handleCloseRightMenu()">
					<i class="el-icon-circle-close"></i> 取消
				</li>
			</template>
		</ul>
	</transition>
</template>

<script>
import router from '@/router'
export default {
  name: 'ContextMenu',
  data () {
    return {
      visible: false, //  右键菜单是否显示
      sortedFileList: [], //  排序后的表格数据
      // 右键菜单
      rightMenu: {
        top: 0,
        left: 0,
        bottom: 'auto',
        right: 'auto'
      },
      // 右键解压缩菜单
      unzipMenu: {
        top: 0,
        bottom: 'auto',
        left: '126px',
        right: 'auto'
      },
      dirImg: require('_a/images/file/dir.png'),
      wordImg: require('_a/images/file/file_word.svg'),
      excelImg: require('_a/images/file/file_excel.svg'),
      pptImg: require('_a/images/file/file_ppt.svg')
    }
  },
  computed: {
    // 路由名称
    routeName () {
      return router.currentRoute.name
    },
    // 左侧菜单选中的文件类型
    fileType () {
      return router.currentRoute.query.fileType
        ? Number(router.currentRoute.query.fileType)
        : 0
    },
    // 当前路径
    filePath () {
      return router.currentRoute.query.filePath
    },
    folderId () {
      return router.currentRoute.query.folderId
    },
    uploadFileBtnShow () {
      return this.folderId != 0
    },
    // 查看按钮是否显示
    seeBtnShow () {
      return this.fileType !== 6 && this.fileType === 0
    },
    wpsBtnShow () {
      return this.fileType !== 6 && this.fileType === 0 && this.selectedFile.isDir === 0
    },
    // 删除按钮是否显示
    deleteBtnShow () {
      return this.selectedFile.isDir === 0 && this.fileType === 0
    },
    // 还原按钮是否显示
    restoreBtnShow () {
      return this.fileType === 6 && !['Share'].includes(this.routeName)
    },
    // 重命名按钮是否显示
    renameBtnShow () {
      return this.permission.folder === 1
    },
    // 下载按钮是否显示
    downloadBtnShow () {
      return this.selectedFile.isDir === 0 && this.fileType === 0
    },
    // 文件详情按钮是否显示
    detailInfoBtnShow () {
      return true
    },
    // 上传文件组件参数
    uploadFileParams () {
      return {
        filePath: this.filePath,
        isDir: 0,
        folderId: router.currentRoute.query.folderId
      }
    }
  },
  watch: {
    /**
     * 监听右键列表状态
     * @description 右键列表打开时，body 添加点击事件的监听
     */
    visible (newValue) {
      if (newValue === true) {
        document.body.addEventListener('click', this.closeRightMenu)
        this.handleOpenContextMenu()
      } else {
        document.body.removeEventListener('click', this.closeRightMenu)
      }
    }
  },
  methods: {
    /**
     * 打开右键菜单
     */
    handleOpenContextMenu () {
      // 纵坐标设置
      if (
        document.body.clientHeight - this.domEvent.clientY <
        document.querySelectorAll('#rightMenuList > .right-menu-item').length *
        36 +
        10
      ) {
        // 如果到底部的距离小于元素总高度
        this.rightMenu.top = 'auto'
        this.rightMenu.bottom = `${document.body.clientHeight - this.domEvent.clientY
          }px`
        this.unzipMenu.top = 'auto'
        this.unzipMenu.bottom = '0px'
      } else {
        this.rightMenu.top = `${this.domEvent.clientY}px`
        this.rightMenu.bottom = 'auto'
        this.unzipMenu.top = '0px'
        this.unzipMenu.bottom = 'auto'
      }
      // 横坐标设置
      if (document.body.clientWidth - this.domEvent.clientX < 138) {
        // 如果到右边的距离小于元素总宽度
        this.rightMenu.left = 'auto'
        this.rightMenu.right = `${document.body.clientWidth - this.domEvent.clientX
          }px`
        this.unzipMenu.left = '-200px'
        this.unzipMenu.right = 'auto'
      } else {
        this.rightMenu.left = `${this.domEvent.clientX + 8}px`
        this.rightMenu.right = 'auto'
        this.unzipMenu.left = '126px'
        this.unzipMenu.right = 'auto'
      }
      this.visible = true
    },
    /**
     * 关闭右键列表
     */
    closeRightMenu (event) {
      if (
        !event.target.className.includes('operate-more-') &&
        !event.target.className.includes('unzip-menu-item')
      ) {
        this.visible = false
        if (this.selectedFile !== undefined) {
          // 不是在空白处右键时
          this.callback('cancel')
        }
      }
    },
    /**
     * 删除按钮点击事件
     * @description 区分 删除到回收站中 | 在回收站中彻底删除，打开确认对话框
     * @param {object} fileInfo 文件信息
     */
    handleDeleteFileBtnClick (fileInfo) {
      if (this.permission.download !== 1) {
        this.$message.warning({ message: '抱歉，你没有此文件夹的删除权限' })
        return false
      }
      this.visible = false
      this.$openDialog
        .deleteFile({
          isBatchOperation: false,
          fileInfo,
          deleteMode: this.fileType === 6 ? 2 : 1 //  删除类型：1-删除到回收站 2-彻底删除
        })
        .then((res) => {
          this.callback(res)
        })
    },
    /**
     * 还原按钮点击事件
     * @description 调用接口，在回收站中还原文件
     * @param {object} fileInfo 文件信息
     */
    handleRestoreFileBtnClick (fileInfo) {
      this.visible = false
      this.$openDialog.restoreFile({ id: fileInfo.id }).then((res) => {
        this.callback(res)
      })
    },
    /**
     * 文件重命名按钮点击事件
     * @description 打开确认对话框让用户输入新的文件名
     * @param {object} fileInfo 文件信息
     */
    handleRenameFileBtnClick (fileInfo) {
      this.visible = false

      if (fileInfo.isDir === 0) { // 重命名文件
        if (this.permission.upload !== 1) {
          this.$message.warning({ message: '抱歉，你没有此文件的重命名权限' })
          return false
        }
        this.$openDialog
          .renameFile({
            oldFileName: fileInfo.fileName,
            userFileId: fileInfo.id
          })
          .then((res) => {
            this.callback(res)
          })
      } else { // 重命名文件夹
        let name, order, folderId, parentId
        folderId = fileInfo.id
        parentId = fileInfo.parentId
        name = fileInfo.fileName
        order = 0
        const fs = fileInfo.filePath.split('/')
        let parentName = fs[fs.length - 1]
        this.$openDialog.addOrEditFolder({ folderId, parentId, name, type: 0, parentName, order, showCascader: true }).then(() => {
          this.callback('confirm')
        })
      }
    },
    /**
       * 下载按钮点击事件
       * @description 打开显示下载进度的对话框
       * @param {object} fileInfo 文件信息
       */
    handleDownloadFile (fileInfo) {
      if (this.permission.download !== 1) {
        this.$message.warning({ message: '抱歉，你没有此文件夹的下载权限' })
        return false
      }
      this.visible = false
      this.$openDialog.downLoadFile({ fileInfo })
    },
    /**
     * 文件详情按钮点击事件
     * @description 打开对话框展示文件完整信息
     * @param {object} fileInfo 文件信息
     */
    handleShowDetailInfo (fileInfo) {
      this.visible = false
      this.$openDialog.showFileDetail({ fileInfo })
    },
    /**
     * 取消按钮点击事件
     */
    handleCloseRightMenu () {
      this.visible = false
    },
    /**
     * 新建文件夹按钮点击事件
     * @description 调用新建文件夹服务，并在弹窗确认回调事件中刷新文件列表
     */
    handleClickAddFolderBtn () {
    },
    /**
     * 上传文件按钮点击事件
     * @description 通过Bus通信，开启全局上传文件流程
     * @param {boolean} uploadWay 上传方式 0-文件上传 1-文件夹上传 2-粘贴图片或拖拽上传
     */
    handleUploadFileBtnClick (uploadWay) {
      if (this.permission.upload !== 1) {
        this.$message.warning({ message: '抱歉，你没有此文件夹的上传权限' })
        return false
      }
      this.$openBox.uploadFile({
        params: this.uploadFileParams,
        uploadWay,
        serviceEl: this.serviceEl,
        callType: true //  callType 调用此服务的方式：1 - 顶部栏，2 - 右键菜单
      })
    }
  },
  created () {
  }
}
</script>

<style lang="scss" scoped>
.right-menu-list {
	position: fixed;
	display: flex;
	flex-direction: column;
	background: #fff;
	border: 1px solid #ebeef5;
	border-radius: 4px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	z-index: 2;
	padding: 4px 0;
	color: #606266;
	list-style: none;

	.el-divider {
		margin: 0 !important;
	}

	.right-menu-item {
		padding: 0 16px;
		height: 36px;
		line-height: 36px;
		cursor: pointer;

		&:hover {
			background: #ecf5ff;
			color: #409eff;
		}

		i {
			margin-right: 8px;
		}
	}

	&.add {
		.right-menu-item {
			display: flex;
			align-items: center;

			img {
				margin-right: 4px;
				height: 20px;
			}

			i {
				margin-right: 4px;
				font-size: 18px;
			}
		}
	}
}

.right-menu-list {
	background: #fff;
	border: 1px solid #ebeef5;
	border-radius: 6px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	z-index: 2;
	padding: 8px 0;
	color: #606266;
	font-size: 14px;
}
</style>
